import React, { useEffect, useState } from 'react'
import './attendance.css'
import {Link} from 'react-router-dom'
import ClockIn from '../../components/clockIn/ClockIn'
import AttendanceDoughnutChart from '../../components/doughnutChart/AttendanceDoughnutChart'
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux'
import { getAttendanceStats, getAttendanceTableStats } from '../../utils'


const columns = [
  { field: 'createdAt', headerName: 'Date', width: 180 },
  {
    field: 'clockIn',
    headerName: 'Clock In',
    width: 180,
  },
  {
    field: 'clockOut',
    headerName: 'Clock Out',
    width: 180,
  },
  {
    field: 'hoursSpent',
    headerName: 'Working Hours',
    width: 180,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 200,
    renderCell: (param) => {
      return (
        <span className={`attendance__body-report_table-status 
        ${param.row.status === 'Present' ? 'present'
        : param?.row?.status === 'Late' ? 'late'
        : param?.row?.status === 'Absent' ? 'absent'
        : param?.row?.status === 'Holiday' ? 'holiday'
        : param?.row?.status === 'On Leave' ? 'onLeave' : ''}`}>
          {param.row.status}
        </span>
      )
    }
  },
];


const Attendance = () => {
  const {user} = useSelector((state)=>state.user)
  const [attendanceData, setAttendanceData] = useState({})
  const [attendanceTable, setAttendanceTable] = useState([])

  
  useEffect(()=>{
    const attendanceStats = getAttendanceStats(user?.attendance);
    const attendanceTableStats = getAttendanceTableStats(user?.attendance)
    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()
    
    const attendanceCurrentMonth = attendanceTableStats?.filter((item)=>{
      const createdDate = new Date(item?.createdAt)
      const Month = createdDate.getMonth() + 1
      const Year = createdDate.getFullYear()

      return Month === currentMonth && Year === currentYear
    })
    
    setAttendanceData(attendanceStats)
    setAttendanceTable(attendanceCurrentMonth)
    
  },[user])


  return (
    <section className='attendance'>

      {/* HEADING */}
      <div className="heading">
        <div className="heading__box">
          <div className="heading-item">
            <h3 className="heading-title">Attendance | </h3>
            <i class='bx bx-home heading__title-icon'></i>
            <Link to="/" className="heading-text">
              Home <i class='bx bx-chevron-right heading-icon'></i>
            </Link>
            <span className="heading-text">
              Attendance <i class='bx bx-chevron-right heading-icon'></i>
            </span>
          </div>
            <p className="heading-text">
              Your attendance is recorded as follows: 
            </p>
        </div>
      </div>

      <div className="attendance__body">

        <div className="attendance__body-item">
          {/* ATTENDANCE CLOCK IN */}
          <ClockIn/>

          {/*  ATTENDANCE STATS */}
          <div className="attendance__body-report">
              <h3 className="attendance__body-report_heading">
                Attendance Report for this Month
              </h3>

              <div className="attendance__body-report_box">

                {/* PRESENT CARD */}
                <div className="attendance__body-report_card">
                  <span className="attendance__body-report_card-icon">
                    <i class='bx bx-user-check'></i>
                  </span>
                  <div className="attendance__body-report_card-item">
                      <h4 className="attendance__body-report_card-title">
                        Present
                      </h4>
                      <span className="attendance__body-report_card-value">
                      {attendanceData?.presentCount}
                      </span>
                  </div>
                </div>

                {/* LATE CARD */}
                <div className="attendance__body-report_card">
                  <span className="attendance__body-report_card-icon">
                    <i class='bx bx-user-minus'></i>
                  </span>
                  <div className="attendance__body-report_card-item">
                      <h4 className="attendance__body-report_card-title">
                        Late
                      </h4>
                      <span className="attendance__body-report_card-value">
                        {attendanceData?.lateCount}
                      </span>
                  </div>
                </div>
                {/* ABSENT CARD */}
                <div className="attendance__body-report_card">
                  <span className="attendance__body-report_card-icon">
                    <i class='bx bx-user-x'></i>
                  </span>
                  <div className="attendance__body-report_card-item">
                      <h4 className="attendance__body-report_card-title">
                        Absent
                      </h4>
                      <span className="attendance__body-report_card-value">
                        {attendanceData?.absentCount}
                      </span>
                  </div>
                </div>

              </div>

          </div>

          {/* ATTENDANCE HOURS CHART */}
          <div className="attendance__body-report">
            <h3 className="attendance__body-report_heading">
              Total hours spent
            </h3>

            <div className="attendance__body-report_chart">
              <AttendanceDoughnutChart hoursSpent={attendanceData?.hoursSpent}/>
            </div>
          </div>
          
        </div>

        {/*  TABLE OF ATTENDANCE RECORDS */}
        <div className="attendance__body-report_table">
          <div className="attendance__body-report_table-search">
              <span>Search:</span>
              <input type="text" placeholder="Search..." 
              className='attendance__body-report_table-input'/>
          </div>
          <div className="attendance__body-report_table-grid">
              <DataGrid
                getRowId={(rows => rows?.id)}
                rows={attendanceTable ?? []}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                disableRowSelectionOnClick
                getRowHeight={() => 'auto'} 
                sx={{
                  '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                    py: 1,
                  },
                  '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                    py: '15px',
                  },
                  '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                    py: '22px',
                  },
                }}
                experimentalFeatures={{ lazyLoading: true }}
              />
          </div>
        </div>
      </div>

    </section>
  )
}

export default Attendance